import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";
import {BaseBackEND}  from "../../services/auth"

import Card1 from "../../assets/img/banners/card1.png"
import Card2 from "../../assets/img/banners/card2.png"


import Cardenfermangem from "../../assets/img/banners/box_courses/enfermagem.jpg"
import CardenfADM from "../../assets/img/banners/box_courses/adm.jpg"
import CARDGD from "../../assets/img/banners/box_courses/gestaoedesenvolvimento.jpg"

class AllCoursesIndex extends Component {

  constructor() {
    super();

    this.state = { 
      categorias: [],
      showcoursebyside:[]
      
    }
      
  }


  async componentWillMount() {

    
      const response1 = await api.post("/categorias",{idunidade:localStorage.getItem('idunidade')});
      this.setState({ 
        categorias: response1.data})



    }

   

  render() {
    const styletextpos ={
      'font-size':14
    }
    return (
      <React.Fragment>
     <div class="container allcourseindex">
     <h2 class="d-flex justify-content-center">Nossos Cursos de Pós-Graduação</h2>

     <div class="catologo-cursod clearfix">
     
     
     
     <nav class="nav flex-column float-left navcoursespos">
     <a class="btn text-white  flex-column  float-left" ><center>Áreas de Atuação</center></a>
     {this.state.categorias.map(el => (
     
      <a class="nav-link" href={'/pos-graduacao/'+el.id}><center>{el.nome}</center></a>

     ))}
    </nav>

   


    <div class="container catologo-cursod ">



        <div class="row boxshows"> 

        {this.state.categorias.map(el => (
          <div class="sizetable">
          <h5>{el.nome}</h5>
            <div class="row imgcursos">
          
            {el.pos_cursos.map(elc => (
               elc.isgraduation==0 &&
               elc.status=='1' &&


             <div class="col-lg-4">
             <div class="card">


        

                              <div class="card-body">
                              
                                
                                <center>
                                {elc.idcategoria!=16 &&
                                  <a style={styletextpos} href={'/pos-graduacao/'+elc.longnome+'/'+elc.id+''} class="card-title">{elc.nome}</a>
                                }
                                {elc.idcategoria==16 &&
                                  <a style={styletextpos} href={'/Curso-Curta-Duracao/'+elc.longnome+'/'+elc.id+''} class="card-title">{elc.nome}</a>
                                }
                                </center>                              
                              </div>
               
                      </div>






              </div>
            ))}
              
             
          
            </div>
          </div>
          
        ))}
















       











        </div>



       



       




        


        


  </div>
  </div>


      





















</div>
        
      </React.Fragment>
       
    );
  }
}

export default withRouter(AllCoursesIndex);


// WEBPACK FOOTER //
// ./src/pages/content/allcourses.js